export const IFRAME_ERROR_SPREEDLY = 'IFrameErrorSpreedly';
export const SPREEDLY_ERROR = 'SpreedlyError';
export const TIMEKIT_BOOKING_ERROR_MESSAGE = 'Failed to create a booking on Timekit';

export const ERROR_DEFAULT = 'default';
export const UNAUTHORIZED_ERROR_CODE = 401;
export const NOT_FOUND_ERROR_CODE = 404;
export const BAD_REQUEST_ERROR_CODE = 400;
export const INTERNAL_SERVER_ERROR_CODE = 500;
